import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { VexModule } from '../@vex/vex.module';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { CustomLayoutModule } from './custom-layout/custom-layout.module';
import { Messages } from './app.messages';
import { LoginClientService } from './client/services/login-client.service';
import { ErrorUtils } from './utils/error.utils';
import { CustomHttpInterceptor } from './services/http-interceptors';
import { JwtModule } from "@auth0/angular-jwt";
import { environment } from 'src/environments/environment';
import { TokenService } from './services/token.service';
import { NgxLoadingModule, ngxLoadingAnimationTypes } from 'ngx-loading';
import { NgxMaskModule } from 'ngx-mask';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { AuthGuard } from './auth.guard';
import { MenuService } from './services/menu.service';
import { MenuModule } from './services/menu.module';

@NgModule({
  declarations: [AppComponent],
  imports: [
    BrowserModule,
    AppRoutingModule,
    MenuModule,
    BrowserAnimationsModule,
    HttpClientModule,
    MatProgressSpinnerModule,
    NgxMaskModule.forRoot(),
    NgxLoadingModule.forRoot({
      animationType: ngxLoadingAnimationTypes.circle, 
      primaryColour: '#00cc00', 
      secondaryColour: '#e6ffe6',
      backdropBorderRadius: '3px'}
      ),
    JwtModule.forRoot({
      config: {
        tokenGetter: TokenService.tokenGetter,
        allowedDomains: [environment.url_accepted]
      },
    }),
    // Vex
    VexModule,
    CustomLayoutModule
  ],
  providers: [
    AuthGuard,
    TokenService,
    MenuService,
    Messages,
    LoginClientService,
    ErrorUtils,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: CustomHttpInterceptor,
      multi: true
    }
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
